import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { formatPhone, parsePhone } from '../../../../helpers/helpers';
import { getDealerRegistrationFormRequest } from '../lib';

export function useDealerRegistrationMutation() {
  return useMutation<
    AxiosResponse<GM.DealerRegistrationForm.Responses.Registration>,
    AxiosError<GM.DealerRegistrationForm.Error[]>,
    GM.DealerRegistrationForm.Props
  >({
    mutationFn: async (formData: GM.DealerRegistrationForm.Props) => {
      const parsedPhone = parsePhone(formData.phone);
      if (parsedPhone === false) {
        throw new Error('Некорректный номер телефона');
      }

      const payload: GM.DealerRegistrationForm.Requests.Registration = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formatPhone(parsedPhone),
        email: formData.email,
        password: formData.password,
        saleSource: 'IIKO' as const,
      };

      try {
        return await getDealerRegistrationFormRequest(payload);
      } catch (error) {
        if (error.response?.data) {
          // Нормализуем data в массив, потому что для разных видов ошибок возвращаются разные ответы
          error.response.data = Array.isArray(error.response.data)
            ? error.response.data
            : [error.response.data];
        }
        throw error;
      }
    },
  });
}
